import { useEffect, useState } from "react";
import { Reveal } from "@/components/site/Reveal";
import { Trophy, Gift, PartyPopper } from "lucide-react";
import { api, API } from "@/lib/api";

export const RecentWinnersSection = () => {
  const [winners, setWinners] = useState(null);

  useEffect(() => {
    api.get("/public/giveaway-winners")
      .then((r) => setWinners(r.data.published ? (r.data.winners || []).slice(0, 6) : []))
      .catch(() => setWinners([]));
  }, []);

  if (!winners || winners.length === 0) return null;

  return (
    <section className="py-24 lg:py-32 relative overflow-hidden" data-testid="recent-winners-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal className="max-w-3xl">
          <div className="inline-flex items-center gap-2 mb-5">
            <span className="h-8 w-8 grid place-items-center rounded-full bg-brand-cyan/15 text-brand-cyan">
              <PartyPopper size={16} />
            </span>
            <span className="text-[10px] uppercase tracking-[0.24em] bg-brand-cyan/15 text-brand-cyan px-3 py-1 rounded-full font-semibold">
              Giveaways
            </span>
          </div>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-white leading-tight">
            RECENT WINNERS
          </h2>
          <p className="mt-6 text-brand-textSec leading-relaxed">
            Congratulations to our latest giveaway winners. Enter the next one — it could be you.
          </p>
        </Reveal>

        <div className="mt-12 flex gap-5 overflow-x-auto pb-4 snap-x snap-mandatory md:grid md:grid-cols-3 md:overflow-visible"
          data-testid="recent-winners-list">
          {winners.map((w, i) => (
            <Reveal key={w.id} delay={i * 0.06} className="snap-start shrink-0 w-72 md:w-auto">
              <div className="card-surface p-6 h-full flex flex-col" data-testid={`recent-winner-${w.id}`}>
                {w.prize_image_file_id ? (
                  <img src={`${API}/giveaway/image/${w.prize_image_file_id}`} alt={w.prize_title || "Prize"}
                    className="rounded-lg h-40 w-full object-cover border border-white/10 mb-4"
                    data-testid={`recent-winner-image-${w.id}`} />
                ) : (
                  <div className="rounded-lg h-40 w-full grid place-items-center bg-brand-cyan/5 border border-white/10 mb-4">
                    <Gift size={40} className="text-brand-cyan/50" />
                  </div>
                )}
                <div className="flex items-center gap-2 text-brand-cyan">
                  <Trophy size={16} />
                  <span className="text-[10px] uppercase tracking-[0.2em] font-semibold">Winner</span>
                </div>
                <h3 className="mt-1.5 font-display font-bold text-white text-xl break-words">{w.name}</h3>
                {w.prize_title && <p className="mt-1 text-brand-textSec text-sm">{w.prize_title}</p>}
                <p className="mt-auto pt-3 text-brand-textMuted text-xs">{String(w.date).slice(0, 10)}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
